import React from 'react'
import {ReactComponent as ArrowDown} from '../../assets/icons/arrow-down.svg'

const ArrowDownIcon = () => {
    return <ArrowDown />
}

export default ArrowDownIcon
